import * as Sentry from '@sentry/react';
import { zustandImmerMiddleware } from '@sketchnote/shared-components';
import { getSession } from 'next-auth/client';
import { UserDetails, useUserAuthentication } from 'src/api/services/authentication/user-auth';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UserDetailsT extends UserDetails {
  isConfettiOn?: boolean;
}
export interface AuthState {
  accessToken: string;
  orgId: string;
  siteUnderMaintanence: boolean;

  setOrgId: (value: AuthState['orgId']) => void;
  isPublicFile?: boolean;
  publicPassword?: string;
  setIsPublicFile: (value: AuthState['isPublicFile']) => void;
  setAccessToken: (value: AuthState['accessToken']) => void;
  setAccessTokenAsync: () => Promise<void>;
  userDetails: UserDetailsT | null;
  setUserDetails: (value: UserDetailsT | null) => void;
  fetchUserDetails: () => Promise<UserDetails | null>;
  stopConfetti: () => void;
  startConfetti: () => void;
  setIsOnboardingComplete: (value: boolean) => void;

  isConfetti: boolean;
  isOnboardingComplete?: boolean;
}

export const useAuth = create<
  AuthState,
  [['zustand/devtools', AuthState], ['zustand/immer', AuthState]]
>(
  devtools(
    zustandImmerMiddleware((set) => ({
      accessToken: '',
      userDetails: null,
      siteUnderMaintanence: false,
      setUserDetails: (value) => {
        Sentry.setUser({ email: value?.email, id: value?.userId, username: value?.name });
        set((state) => {
          state.userDetails = value;
        });
      },
      orgId: '',
      setOrgId: (value) => set((state) => ({ ...state, orgId: value })),

      isPublicFile: false,
      setIsPublicFile: (value) => set((state) => ({ ...state, isPublicFile: value })),

      isConfetti: false,
      isOnboardingComplete: false,
      setAccessToken: (value) => set((state) => ({ ...state, accessToken: value })),
      setAccessTokenAsync: async () => {
        const session = await getSession();
        const token = session?.accessToken;
        if (typeof token === 'string') {
          set((state) => ({ ...state, accessToken: token }));
        }
      },
      fetchUserDetails: async () => {
        const userDetails = await useUserAuthentication().fetchUserDetails();
        if (userDetails) {
          set((s) => {
            s.userDetails = { ...s.userDetails, ...userDetails };
          });
        }
        return userDetails;
      },
      stopConfetti: () =>
        set((s) => {
          s.isConfetti = false;
        }),
      startConfetti: () =>
        set((s) => {
          s.isConfetti = true;
        }),
      setIsOnboardingComplete: (value) =>
        set((s) => {
          s.isOnboardingComplete = value;
        }),
    }))
  )
);
